module.exports = __webpack_public_path__ + "static/media/22ESCWA19.a01ab02b.jpg";